import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PipesModule } from '@jht/brand-pipes';
import { TranslateModule } from '@jht/brand-translate';

import { BASE_SUFFIXES } from '../translation-suffixes';
import { PartialsHelpersService } from '../partials-helpers.service';
import { SideBySideComponent } from '../../../shared/components/side-by-side/side-by-side.component';

@Component({
    selector: 'vision2-section-6',
    imports: [CommonModule, PipesModule, TranslateModule, SideBySideComponent],
    templateUrl: './section-6.component.html',
    styleUrl: './section-6.component.scss',
})
export class Section6Component implements OnChanges {
    @Input() productData: any;
    groupedContent: Record<string, any[]> = {};
    hasValidTranslations = false;

    constructor(private helpers: PartialsHelpersService) {}

    ngOnChanges(changes: SimpleChanges): void {
        this.getTranslations();
    }

    getTranslations(): void {
        this.groupedContent = {
            'SECTION-6': this.helpers.translateContentGroup(
                this.productData,
                'SECTION-6',
                BASE_SUFFIXES,
                [],
            ),
            'SECTION-6_IMAGE-GALLERY_IMAGE': this.helpers.translateContentGroup(
                this.productData,
                'SECTION-6_IMAGE-GALLERY_IMAGE',
                BASE_SUFFIXES,
                [0, 1, 2, 3, 4],
            ),
            'SECTION-6_SIDE-BY-SIDE': this.helpers.translateContentGroup(
                this.productData,
                'SECTION-6_SIDE-BY-SIDE',
                BASE_SUFFIXES,
                [0, 1, 2, 3],
            ),
        };

        this.hasValidTranslations = this.helpers.hasValidTranslation(
            this.groupedContent,
        );
    }

    getColumnClass(index: number): string {
        // Determine the column class based on the index
        if (index % 4 === 0 || index % 4 === 3) {
            return 'col-md-5';
        } else {
            return 'col-md-7';
        }
    }
}
